import { IPaymentSettingsItem } from "web/types/Payment";

import { BANK_PAYMENTS_TYPE } from "../consts";

const sortRuleBankSub10Products = (
  firstPayment: IPaymentSettingsItem,
  secondPayment: IPaymentSettingsItem,
  context: { banksSub10Products: Set<string> }
) => {
  const { banksSub10Products } = context;

  if (
    firstPayment.type !== BANK_PAYMENTS_TYPE ||
    secondPayment.type !== BANK_PAYMENTS_TYPE
  ) {
    return 0;
  }

  const firstIsSub10 = banksSub10Products?.has(firstPayment.code);
  const secondIsSub10 = banksSub10Products?.has(secondPayment.code);

  if (firstIsSub10 && !secondIsSub10) {
    return -1;
  }

  if (!firstIsSub10 && secondIsSub10) {
    return 1;
  }

  return 0;
};

export default sortRuleBankSub10Products;
